import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUi from 'element-ui'
import router from './router'
import store from './store'
import axios from 'axios'
import util from '@/util/util'
import { isLmMobileUserAgent, redirectToLmMobileAigcCreate } from '@/views/lmMobileNavigate'
import { completeWxLogin } from '@/util/loginAuth'
import { isWxLoginMessage } from '@/util/wxLoginBridge'
import { Message } from 'element-ui'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'

Vue.use(ElementUi)
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.config.productionTip = false

let authExpiredRedirectScheduled = false

function isLmConsoleMobileUserAgent() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
}

function isTokenExpiredPayload(payload) {
  const p = payload && typeof payload === 'object' ? payload : {}
  const status = p.status
  if (status === -2) return true
  if (status !== 0) return false
  const msg = String(p.message || p.msg || p.error_msg || '').toLowerCase()
  return msg.indexOf('token') !== -1 && (msg.indexOf('过期') !== -1 || msg.indexOf('expired') !== -1)
}

function redirectOnLoginExpired() {
  if (authExpiredRedirectScheduled) return
  authExpiredRedirectScheduled = true
  store.commit('resetUserInfo')
  util.removeAllInfo()
  if (isLmConsoleMobileUserAgent()) {
    const m = String(process.env.TEMPLATE_M_URL || '').trim().replace(/\/+$/, '')
    if (m) {
      window.location.href = `${m}/#/aigc/login`
      return
    }
  }
  window.location.hash = '#/login'
}

axios.interceptors.request.use(config => {
  if (util.getCookie('front_token')) {
    config.headers.Authorization = util.getCookie('front_token')
  }
  return config
}, error => Promise.reject(error))

axios.interceptors.response.use(response => {
  const res = response.data
  if (isTokenExpiredPayload(res)) {
    redirectOnLoginExpired()
    return Promise.reject(new Error('登录过期'))
  }
  return response
}, error => {
  const resp = error && error.response
  if (resp) {
    const data = resp.data
    if (resp.status === 401 || isTokenExpiredPayload(data)) {
      redirectOnLoginExpired()
      return Promise.reject(new Error('登录过期'))
    }
  }
  return Promise.reject(error)
})

Vue.prototype.Axios = axios
Vue.prototype.Axios.defaults.baseURL = process.env.BASE_URL
Vue.prototype.ImageUrl = process.env.BASE_URL
Vue.prototype.Env = process.env.NODE_ENV
Vue.prototype.FrontUrl = process.env.TEMPLATE_URL
Vue.prototype.MobileUrl = process.env.TEMPLATE_M_URL
Vue.prototype.WatingTime = 1000

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next({ path: '/aigc/home' })
    return
  }
  const hasToken = util.getCookie('front_token')
  const isLoginPage = to.path === '/login' || to.name === 'login'
  const isWxAuthPage = to.name === 'wx_callback' || to.name === 'user_wx_callback' || to.name === 'wx_bind'
  const isLargeModelRoute = to.path.indexOf('/aigc') === 0 || to.path.indexOf('/large-model') === 0
  const isAigcHome = to.name === 'lm_home' || to.path === '/aigc' || to.path.indexOf('/aigc/home') === 0
  const isPublicRoute = to.name === 'lm_real_human_liveness' || isWxAuthPage

  if (isLoginPage || isWxAuthPage) {
    if (hasToken) {
      next({ name: 'lm_image_create' })
    } else {
      next()
    }
    return
  }
  if (isPublicRoute) {
    next()
    return
  }
  if (hasToken) {
    if (to.name === 'lm_image_create' && isLmMobileUserAgent()) {
      if (redirectToLmMobileAigcCreate(process.env.TEMPLATE_M_URL)) return
    }
    next()
    return
  }
  store.commit('resetUserInfo')
  util.removeAllInfo()
  if (isAigcHome) {
    next()
  } else if (isLargeModelRoute) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next({ path: '/login' })
  }
})

router.afterEach((to) => {
  try {
    if (to && (to.path === '/login' || to.name === 'login')) {
      authExpiredRedirectScheduled = false
    }
    const aigcBase = '白云AIGC短剧创作平台'
    const t = to && to.meta && to.meta.title ? String(to.meta.title) : ''
    document.title = t ? `${t} - ${aigcBase}` : aigcBase
  } catch (e) {}
})

function handleWxLoginMessage(e) {
  if (!isWxLoginMessage(e.data)) return
  const code = String(e.data.code)
  const state = e.data.state ? String(e.data.state) : ''
  completeWxLogin(
    {
      axios,
      store,
      router,
      route: router.currentRoute,
      onError(msg) {
        Message.error(msg)
      },
    },
    code,
    state
  ).catch(() => {})
}

window.addEventListener('message', handleWxLoginMessage)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js